import React from "react";
import {cx} from "../../lib/ClassSet";
import "./CartItem.css";

const CartItem = (props) => {

  let {data} = props;
  
  let classes = cx({
    "item": true,
    "sales-cart-list-item": true,
    "u-subscription": data.get("subscription") === true,
    "u-selected": props.selected
  })

  let subtotal = null;
  if (props.showSubtotal) {
    subtotal = <td className="field f-subtotal u-nowrap">{data.get("subtotal")} <span className="currency">{data.get("currency")}</span></td>
  }

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("productTitle")} <span className="sku">{data.get("productSku")}</span></td>
      <td className="field f-quantity u-nowrap">{data.get("quantity")}</td>
      <td className="field f-price u-nowrap">{data.get("unitPrice")} <span className="currency">{data.get("currency")}</span></td>
      {subtotal}
    </tr>
  )
}

CartItem.defaultProps = {
  showSubtotal: true
}

export default CartItem;